import { h } from 'preact';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';
import { getMyOrganizations } from '../../apis/rpm.js';
import { makeSimpleLazyList } from '../lazyList/lazyList.jsx';
import ReactiveItemLink from './reactiveItemLink.jsx';

function LazyOrganization(_props) {
  return (
    <ListItem>
      <Skeleton height={48} width={200} />
    </ListItem>
  );
}

function OrganizationItem(organization) {
  return (
    <ReactiveItemLink href={`/organization/${organization._id}`}>
      <ListItem>
        <ListItemText>{organization.name}</ListItemText>
      </ListItem>
    </ReactiveItemLink>
  );
}

const OrganizationLazyList = makeSimpleLazyList(
  getMyOrganizations,
  5,
  LazyOrganization,
  OrganizationItem,
  {}
);

export default function OrganizationList(_props) {
  return <OrganizationLazyList />;
}
